export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <img
        src="https://public.readdy.ai/ai/img_res/2386f1c2b16fb10ffab72888e315b631.jpg"
        alt="American home powered and protected with backup power solutions"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-5xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/40 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-6 uppercase tracking-widest">
          <i className="ri-shield-check-line"></i>
          U.S.-Based · Authorized Dealer · Real Guidance
        </div>

        <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
          Backup Power Starts With<br />
          <span className="text-amber-400">the Right Plan</span>
        </h1>

        <p className="text-gray-200 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Not sure what system your home actually needs? We break it down step-by-step — then show you exactly what to buy.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="#calculator"
            className="bg-amber-500 hover:bg-amber-400 text-white font-bold px-10 py-4 rounded-md text-base transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-survey-line"></i>
            </div>
            Start My Plan
          </a>
          <a
            href="https://ironhavensupply.com/collections/home-backup-power"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white/50 hover:border-amber-400 hover:text-amber-400 text-white font-semibold px-10 py-4 rounded-md text-base transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-store-2-line"></i>
            </div>
            Shop Power Systems
          </a>
        </div>

        {/* Trust line */}
        <div className="flex flex-wrap items-center justify-center gap-5 text-white/80 text-sm">
          {[
            { icon: "ri-map-pin-line", label: "U.S.-Based Support" },
            { icon: "ri-verified-badge-line", label: "Authorized Dealer" },
            { icon: "ri-truck-line", label: "Fast Shipping" },
            { icon: "ri-compass-discover-line", label: "Real Guidance" },
          ].map((b) => (
            <div key={b.label} className="flex items-center gap-2 whitespace-nowrap">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${b.icon} text-amber-400`}></i>
              </div>
              <span>{b.label}</span>
            </div>
          ))}
        </div>

        {/* Rating badge */}
        <div className="mt-10 flex items-center justify-center">
          <div className="inline-flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5">
            <div className="flex -space-x-2 flex-shrink-0">
              {[
                "https://readdy.ai/api/search-image?query=friendly%20smiling%20family%20woman%20portrait%20headshot%20warm%20amber%20background%20realistic%20photo&width=40&height=40&seq=hrav1&orientation=squarish",
                "https://readdy.ai/api/search-image?query=friendly%20smiling%20father%20man%20portrait%20headshot%20natural%20warm%20background%20realistic%20photo&width=40&height=40&seq=hrav2&orientation=squarish",
                "https://readdy.ai/api/search-image?query=smiling%20homeowner%20woman%20in%20her%2030s%20portrait%20headshot%20clean%20warm%20background%20realistic%20photo&width=40&height=40&seq=hrav3&orientation=squarish",
              ].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="Iron Haven Supply customer"
                  className="w-7 h-7 rounded-full border-2 border-white/30 object-cover"
                />
              ))}
            </div>
            <div className="w-px h-5 bg-white/20 flex-shrink-0"></div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                ))}
              </div>
              <span className="text-white font-bold text-sm">4.8</span>
              <span className="text-white/60 text-xs">·</span>
              <span className="text-white/75 text-xs whitespace-nowrap">1,247 families protected</span>
            </div>
            <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
              <i className="ri-verified-badge-fill text-amber-400 text-sm"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-xl"></i>
        </div>
      </div>
    </section>
  );
}
